var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconMartini = function SvgIconMartini(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.25 2.75a1 1 0 0 0-.707 1.707l3.375 3.375L11 13.914v5.336H8.25a1 1 0 1 0 0 2h7.5a1 1 0 1 0 0-2H13v-5.336l9.457-9.457a1 1 0 0 0-.707-1.707zm5.79 5.375 3.96 3.96 3.96-3.96zm9.92-2 1.376-1.375H4.664L6.04 6.125z",
    clipRule: "evenodd"
  })));
};
export default SvgIconMartini;